import HighLightWords from "@dropDesk/presentation/components/high_light_words";
import React, {useEffect} from "react";
import {useInjection} from "inversify-react";
import {observer} from "mobx-react";
import SelectSearchRemote from "@dropDesk/presentation/components/inputs/select_search_remote";
import {SelectFilter} from "@dropDesk/domain/entities/generic/info_origin.enum";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";
import {Select} from "antd";
import {
    ContainerColumn,
    ContainerHeaderColumn,
    ContainerHeaderText,
    ContentColumn,
    TextMainEllipsis,
} from "./styled";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {setBlockUpdateLocalSearchCache} from "@dropDesk/utils/helpers/common";
import {
    SelectSearchSearchSectorType
} from "@dropDesk/presentation/components/inputs/select_search_sectors/select_search_sectors";
import {SectorController} from "@dropDesk/presentation/pages/sector/controller/sector.controller";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";

const {Option} = Select;

const SelectSearchSector = observer((props: SelectSearchSearchSectorType) => {


    const sectorController = useInjection(SectorController);
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const idUser = appController.isUserClient ? undefined : props.idUser;

    useEffect(() => {
        initialize();
    }, []);

    const initialize = () => {
        sectorController.tableSectors.limit = ConstantsKeys.defaultLimitSelectSearchItems;
        sectorController.setFilterListableForClients(appController.isUserClient ? 'true' : null);
    }

    const onSearch = (searchParam: string): void => {
        setBlockUpdateLocalSearchCache(true);
        sectorController.list(searchParam, idUser);
    }

    const itemWidth = 200;

    const options =
        <>
            {sectorController.tableSectors.data.map(sector => (
                <Option key={sector.id} value={sector.id} label={sector?.realName(appController.user!) ?? ''} data={sector}>
                    <ContainerColumn>
                        <ContentColumn width={itemWidth}>
                            <TextMainEllipsis>
                                <HighLightWords
                                    searchWords={sectorController.searchParam}
                                    textToHighlight={sector?.realName(appController.user!) ?? ''}
                                    fontSize={13}
                                />
                            </TextMainEllipsis>
                        </ContentColumn>
                        <ContentColumn width={itemWidth}>
                            <TextMainEllipsis>
                                <HighLightWords
                                    searchWords={sectorController.searchParam}
                                    textToHighlight={sector.note ?? ''}
                                    fontSize={13}
                                />
                            </TextMainEllipsis>
                        </ContentColumn>
                    </ContainerColumn>
                </Option>
            ))}
        </>

    const optionsHeader =
        <ContainerHeaderColumn>
            <ContainerHeaderText color={colors.hintInverse} width={itemWidth}>Nome</ContainerHeaderText>
            <ContainerHeaderText color={colors.hintInverse} width={itemWidth}>Observação</ContainerHeaderText>
        </ContainerHeaderColumn>


    return (
        <SelectSearchRemote<SectorEntity>
            onChange={(filter, sector) => {
                props.handleSelectSector(filter, sector);
            }}
            onClickRemoveFilter={() => {
                sectorController.tableSectors.page = 0;
            }}
            disabled={props.disabled}
            onSearch={(value) => onSearch(value)}
            size={props.size}
            useRemoveFilter={props.useRemoveFilter}
            width={props.width}
            widthPopup={props.widthPopup ?? 632}
            label={props.label}
            placeHolder={props.placeHolder}
            value={props.value}
            loading={sectorController.loading}
            options={options}
            optionsLength={sectorController.tableSectors.data.length}
            search={true}
            searchValue={sectorController.searchParam}
            hasMore={sectorController.tableSectors.hasMore}
            loadMore={() => sectorController.loadMoreDataFromPage()}
            messageError={props.messageError}
            required={props.required}
            iconLeftName={props.iconLeftName}
            borderColor={props.borderColor}
            dropdownRender={menu => (
                <>
                    {optionsHeader}
                    {menu}
                </>
            )}
        />
    )
});
export default SelectSearchSector;
